<template>
	<div class="class">
		<teacherNav :current="current" @info-event="myInfoEvent" @public-event="publicEvent"></teacherNav>
		<div class="class_cont bg_blue">
			<div class="class_div radius8 bs bg_white">
				<div class="class_title flex">
					<p class="f30px cl_dark">作业记录</p>
				</div>
				<div class="task_record">
					<div class="record_search flex mat30">
						<div class="class_screen_l flex">
							<input type="text" placeholder="输入关键词搜索作业" v-model="task_name" class="class_screen_input radius20" />
							<button class="class_screen_submit radius20 cl_white" @click="search">搜索</button>
						</div>
					</div>
					<div class="task_paper_screen mat30">
						<div class="test_screen cl_gray">
							<div class="test_screen_l f16px"><span class="inline">学科</span><i class="inline">：</i></div>
							<div class="test_screen_r tc">
								<span class="test_screen_list bg_gray" v-for="(item,index) in subject" :key="index" :class="{'on':item.subjectId==subject_cur}" @click="subjectCheck(item.subjectId)">{{item.subjectName}}</span>
							</div>
						</div>
						<div class="test_screen cl_gray">
							<div class="test_screen_l f16px"><span class="inline">布置时间</span><i class="inline">：</i></div>
							<div class="test_screen_r tc">
								<el-date-picker v-model="time_range" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
								 :picker-options="rangeTimeOption" @change="rangeChange"></el-date-picker>
							</div>
						</div>
						<div class="record_select_cont mat20">
							<div class="famous_screen_list flex">
								<span class="cl_gray f16px">布置年级：</span>
								<el-select v-model="grade_cur" clearable placeholder="请选择布置年级" @change="gradeSelect">
									<el-option v-for="(item,index) in grade":key="index" :label="item.gradeName":value="item.gradeId"></el-option>
								</el-select>
							</div>
							<div class="famous_screen_list flex">
								<span class="cl_gray f16px">类型：</span>
								<el-select v-model="type_cur" clearable placeholder="请选择类型" @change="typeSelect">
									<el-option v-for="(item,index) in type":key="index" :label="item.name":value="item.id"></el-option>
								</el-select>
							</div>
							<div class="famous_screen_list flex">
								<span class="cl_gray f16px">状态：</span>
								<el-select v-model="status_cur" clearable placeholder="请选择作业状态" @change="statusSelect">
									<el-option v-for="(item,index) in status":key="index" :label="item.name":value="item.id"></el-option>
								</el-select>
							</div>
						</div>
					</div>
					<div class="task_video_cont mat30" v-if="list.length > 0">
						<div class="flex record_list" v-for="(item,index) in list" :key="index">
							<div class="record_list_l">
								<div class="record_list_title">
									<span class="cl_white record_list_type">{{item.type_name}}</span>
									<span class="cl_violet record_list_subject">{{item.subject_name}}</span>
									<span class="f20px cl_dark">{{item.name}}</span>
								</div>
								<div class="record_list_item_cont cl_gray mat15">
									<div class="record_list_item">
										<p>开始时间：{{item.from_time}}</p>
										<p class="mat5">截止时间：{{item.to_time}}</p>
									</div>
									<div class="record_list_item">
										<p>已参与人数：{{item.class_join_num}}/{{item.class_all_num}}</p>
										<p class="mat5">已完成人数：{{item.class_done_num}}/{{item.class_all_num}}</p>
									</div>
									<div class="record_list_item">
										<p>布置人：{{item.add_user_name}}</p>
									</div>
								</div>
								<div class="record_list_user cl_gray mat15">
									<span>布置对象:</span>
									<span class="record_list_user_r">{{item.class_name}}</span>
								</div>
							</div>
							<div class="record_list_r tc">
								<p>{{item.status}}</p>
								<div class="flex mat30">
									<el-popover placement="bottom" width="120" trigger="click" class="inline">
									  <div class="record_list_btn_cont tc">
											<button class="f16px cl_gray record_list_btn" @click="edit(index)"
											 :disabled="['未开始','进行中'].indexOf(item.status) < 0">修改作业信息</button>
											<button class="f16px cl_gray record_list_btn" @click="recall(item.id)"
											 :disabled="['未开始','进行中'].indexOf(item.status) < 0">撤回作业</button>
											<button class="f16px cl_gray record_list_btn" @click="again(item.id)">再次布置</button>
										</div>
									  <el-button slot="reference" class="cl_violet f14px record_list_more">更多操作</el-button>
									</el-popover>
									<router-link :to="{ path: '/record_details', query: { id: item.id }}" class="cur mal20 record_list_details tc cl_white f16px">作业详情</router-link>
								</div>
							</div>
						</div>
					</div>
					<div class="famous_page flex" v-if="list.length > 0">
						<div class="famous_page_l f16px cl_gray"> </div>
						<div class="famous_page_r cl_dark">
							<el-pagination background layout="prev, pager, next"
							@current-change="handleCurrentChange" :page-size="pageSize" :current-page="currentPage" :total="total"></el-pagination>
						</div>
					</div>
					<div class="choice_empty tc f18px cl_gray" v-if="list.length == 0">
						<p>找不到内容，请重新选择。</p>
					</div>
				</div>
			</div>
		</div>
		<!-- 布置作业 -->
		<el-dialog title="修改作业信息" center :visible.sync="outerVisible" width="40%">
			<div class="basket_dialog_cont">
				<div class="basket_dialog_item">
					<div class="basket_dialog_item_l f16px cl_dark"><span>作业标题</span></div>
					<div class="basket_dialog_item_r">
						<input type="text" v-model="basket_name" maxlength="20" placeholder="作业标题" class="f16px basket_dialog_item_input" />
					</div>
				</div>
				<div class="basket_dialog_item">
					<div class="basket_dialog_item_l f16px cl_dark"><span>布置对象</span></div>
					<div class="basket_dialog_item_r">
						<span class="cl_violet inline basket_dialog_object">{{cur.class_name}}</span>
					</div>
				</div>
				<div class="basket_dialog_item" v-show="start_check == true">
					<div class="basket_dialog_item_l f16px cl_dark"><i class="cl_red">*</i><span>作业截止时间</span></div>
					<div class="basket_dialog_item_r">
						<el-date-picker v-model="end_time" type="datetime" placeholder="选择日期时间"
						 :picker-options="endTimeOption"></el-date-picker>
					</div>
				</div>
				<div class="basket_dialog_item" v-show="start_check == false">
					<div class="basket_dialog_item_l f16px cl_dark"><i class="cl_red">*</i><span>作业开始与截止时间</span></div>
					<div class="basket_dialog_item_r">
						<el-date-picker v-model="time_range2" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
						 :picker-options="rangeTimeOption2"></el-date-picker>
					</div>
				</div>
			</div>
			<div class="basket_dialog_btm tc mat50">
				<button type="button" class="basket_dialog_submit f18px cl_white radius20" @click="submit()">确认修改</button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import teacherNav from '../../components/teacher_nav.vue'
	
	export default {
		name: 'record',
		components: {
			teacherNav,
		},
		props: {
			
		},
		data () {
			return {
				myInfo: {},
				public: {},
				current: {
					navCur: 4,
					listCur: 0,
					open: 0,
				},
				task_name: "", //搜索关键词
				name: "",
				subject: [], //学科
				subject_cur: "",
				grade: [], //年级
				grade_cur: "",
				type: [
					{
						id: "all",
						name: "混合",
					},{
						id: "video",
						name: "视频",
					},{
						id: "test",
						name: "组卷",
					},{
						id: "papers",
						name: "试卷",
					},{
						id: "exam",
						name: "校本试卷",
					},
				], //类型
				type_cur: "",
				status: [
					{
						id: 1,
						name: "未开始",
					},{
						id: 2,
						name: "进行中",
					},{
						id: 3,
						name: "已截止",
					},{
						id: 4,
						name: "已撤回",
					},
				], //状态
				status_cur: "",
				period_time: "",
				list: [],
				currentPage: 1, //当前页数
				pageSize: 20, //每页数量
				total: 0, //总页数
				time_range: "",
				rangeTimeOption: {},
				outerVisible: false, //修改
				start_check: false,
				cur: {},
				basket_name: "",
				end_time: "",
				endTimeOption: {
				  disabledDate: date => {
						return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
				  }
				},
				time_range2: "",
				rangeTimeOption2: {
				  disabledDate: date => {
						return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
				  }
				},
			}
		},
		created() {
			
		},
		mounted() {
			this.getSubject();
			this.getGrade();
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			//学科
			getSubject () {
				this.$get("/api/material/get_subject_data",{})
				.then(res => {
					res.data.unshift({subjectId: "", subjectName: "全部"});
					this.subject = res.data;
					this.subject_cur = this.subject[0].subjectId;
					this.getList();
				});
			},
			subjectCheck (e) {
				this.subject_cur = e;
				this.currentPage = 1;
				this.getList();
			},
			//年级
			getGrade () {
				this.$get("/api/teacher/get_school_grade_data",{
					token: localStorage.getItem("token"),
				})
				.then(res => {
					this.grade = res.data;
				});
			},
			gradeSelect () {
				this.currentPage = 1;
				this.getList();
			},
			typeSelect () {
				this.currentPage = 1;
				this.getList();
			},
			statusSelect () {
				this.currentPage = 1;
				this.getList();
			},
			search () {
				this.name = this.task_name;
				this.currentPage = 1;
				this.getList();
			},
			rangeChange () {
				if (this.time_range == null) {
					this.time_range = "";
					this.period_time = "";
				} else {
					this.period_time = this.getTime(this.time_range[0])+"~"+this.getTime(this.time_range[1]);
				}
				this.currentPage = 1;
				this.getList();
			},
			//记录
			getList () {
				this.$get("/api/teacher/get_homework_list",{
					token: localStorage.getItem("token"),
					name: this.name,
					subject_id: this.subject_cur,
					period_time: this.period_time,
					grade_id: this.grade_cur,
					type: this.type_cur,
					status: this.status_cur,
					page: this.currentPage,
					limit: this.pageSize,
				})
				.then(res => {
					this.list = res.data.data;
					this.total = res.data.total;
				});
			},
			getTime (time) {
				let t = "";
				let myDate = new Date(time);
				let year = myDate.getFullYear();
				let month = myDate.getMonth() + 1;
				let date = myDate.getDate();
				let hours = myDate.getHours();
				let minutes = myDate.getMinutes();
				let seconds = myDate.getSeconds();
				if (month < 10) {
					month = "0" + month;
				}
				if (date < 10) {
					date = "0" + date;
				}
				if (hours < 10) {
					hours = "0" + hours;
				}
				if (minutes < 10) {
					minutes = "0" + minutes;
				}
				if (seconds < 10) {
					seconds = "0" + seconds;
				}
				t = year + "-" + month + "-" + date + " " + hours + ":" + minutes + ":" + seconds
				return t;
			},
			//撤回
			recall (id) {
				this.$messageBox.confirm('确定撤回吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					this.$get("/api/teacher/post_homework_withdraw",{
						token: localStorage.getItem("token"),
						id: id,
					})
					.then(res => {
						this.$message({
							duration: 1500,
							message: res.msg,
							type: 'success'
						});
						this.getList();
					});
				}).catch(() => {
					
				});
			},
			//再次布置
			again (id) {
				this.$get("/api/teacher/post_homework_anew",{
					token: localStorage.getItem("token"),
					id: id,
				})
				.then(res => {
					this.$router.push({path: '/basket'});
				});
			},
			//修改
			edit (index) {
				this.outerVisible = true;
				this.cur = this.list[index];
				this.basket_name = this.cur.name;
				this.time_range2 = "";
				this.end_time = "";
				if (this.cur.status == "未开始") {
					this.start_check = false;
				} else {
					this.start_check = true;
				}
			},
			submit () {
				let from_time = "";
				let to_time = "";
				if (this.basket_name == "") {
					this.$message({
						type: 'warning',
						message: '作业标题不能为空',
						duration: 1500,
					});
					return false
				}
				if (this.cur.status == "未开始") {
					if (this.time_range2 == "" || this.time_range2 == null) {
						this.$message({
							type: 'warning',
							message: '请选择开始与截止时间',
							duration: 1500,
						});
						return false
					}
					from_time = this.getTime(this.time_range2[0]);
					to_time = this.getTime(this.time_range2[1]);
				} else if (this.cur.status == "进行中") {
					if (this.end_time == "") {
						this.$message({
							type: 'warning',
							message: '请选择截止时间',
							duration: 1500,
						});
						return false
					}
					to_time = this.getTime(this.end_time);
				}
				this.$get("/api/teacher/post_homework_id_edit",{
					token: localStorage.getItem("token"),
					id: this.cur.id,
					name: this.basket_name,
					from_time: from_time,
					to_time: to_time,
				})
				.then(res => {
					this.$message({
						type: 'success',
						message: res.msg,
						duration: 1500,
					});
					this.outerVisible = false;
					this.getList();
				});
			},
			handleCurrentChange: function(currentPage){
				this.currentPage = currentPage;
				this.getList();
			},
		},
	}
</script>

<style>
</style>
